<template>
  <div class="Coupon">
    <div class="imgArea" :style="'background-image: url(' + src + ')'"></div>
    <div class="textArea">
      <div>{{ description }}</div>
      <div class="advertise">{{ advertise }}</div>
      <div>{{ toymd }}</div>
      <div class="kind">{{ getKind }}</div>
    </div>
  </div>
</template>

<script>
import { ymd } from "../assets/js/util";

export default {
  name: "Coupon",
  props: {
    imagePath: {
      type: String,
      require: true
    },
    advertise: {
      type: String,
      require: true
    },
    startTime: {
      type: Number,
      default: 0
    },
    endTime: {
      type: Number,
      default: 0
    },
    useNum: {
      type: Number,
      require: true
    },
    description: {
      type: String,
      require: true
    }
    ,
    kind: {
      type: Number,
      require: true
    }
  },
  computed: {
    src() {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + this.imagePath
    },
    toymd() {
      const start = ymd(this.startTime);
      const end = ymd(this.endTime);
      // endが2099/1/1以降になっているものは無期限表示にする
      if(4070876400 > this.endTime) {
        return `${start[0]}/${start[1]}/${start[2]} ~ ${end[0]}/${end[1]}/${end[2]}`
      } else {
        return '無期限'
      }
    },
    getKind() {
      switch(this.kind) {
        case 1: return '￥100円OFF';
        case 2: return '￥200円OFF';
        case 3: return '1PLAY無料';
        case 4: return '';
        case 5: return 'プリもっと獲得';
        case 6: return '全データダウンロード';
        default: return null;
      }
    },
    struseNum() {
      if(this.useNum === 0) return '回数制限なし'
      return `${ this.useNum }回限り`
    }
  }
}
</script>

<style lang="scss" scoped>
.Coupon {
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
  font-size: 12px;
  color: #4B4344;
  overflow: hidden;
  border: 1px solid #E1DADB;
  .imgArea {
    width: 100%;
    height: 177px;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }
  .textArea {
    position: relative;
    margin: 5px 10px;
    .advertise {
      font-size: 1.2em;
      font-weight: bold;
    }
    .kind {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 1.4em;
      color: #EF2562;
    }
  }
}
.new {
  color: red;
  font-size: 12px;
  margin: 8px;
}
</style>
